"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.5.0'] && _();
}
catch (e) { }
